import { useContext } from 'react';
import { AgGridContext } from '..';

export const useGridLoading = (): [isLoading: React.MutableRefObject<boolean>, (loading: boolean) => void] => {
    const context = useContext(AgGridContext);
    if (!context) {
        throw new Error('useGridLoading must be used within an AgGridProvider');
    }
    return context.loadingState;
};

export default useGridLoading;